import React, { FC, useState, useEffect } from 'react';
import { IDResource, IEvents, ICurrentAnetaPack } from 'types';
import { getAnetaPackById as getAnetaPackByIdAction } from 'actions/aneta-pack';
import { getTimeWithTimeZone } from 'utils/helpers/momentTime';
import _ from 'lodash';
import { IRootState } from 'store';
import { connect } from 'react-redux';
import moment from 'moment';
import buttons from 'style/buttons.module.scss';
import Homeroom from './homeroom';
import Schedule from './schedule';
import styles from '../index.module.scss';

const mstp = (state: IRootState) => state.anetaPack;
interface AnetapackContentProps {
  selectedAnetaPackId: number;
  currentAnetaPack?: ICurrentAnetaPack;
  getAnetaPackById?: (id: number) => void;
  handleClose: () => void;
  openNext: () => void;
}

const AnetapackContent: FC<AnetapackContentProps> = ({
  handleClose,
  openNext,
  getAnetaPackById,
  selectedAnetaPackId,
  currentAnetaPack,
}) => {
  const [resources, setResources] = useState<IDResource[]>([]);
  const [events, setEvents] = useState<IEvents[] | []>([]);

  useEffect(() => {
    setResources(currentAnetaPack?.digitalResources || []);
    const eventsWithTimezome = _.map(
      _.flatten(_.values(currentAnetaPack?.events)),
      (el) => {
        return {
          ...el,
          startTimeStr: getTimeWithTimeZone(el.startTimeStr, 'HH:mm'),
          endTimeStr: getTimeWithTimeZone(el.endTimeStr, 'HH:mm'),
        };
      }
    );
    setEvents(eventsWithTimezome);
  }, [currentAnetaPack]);

  useEffect(() => {
    if (selectedAnetaPackId && getAnetaPackById) {
      getAnetaPackById(selectedAnetaPackId);
    }
  }, [selectedAnetaPackId, getAnetaPackById]);

  return (
    <div className={styles.anetapackContentRoot}>
      <div className={styles.anetapackContentHeader}>
        <span className="deep-gray-heading">{`${currentAnetaPack?.anetaPack?.name} Contents`}</span>
      </div>
      <div className={styles.anetapackContentMain}>
        <div>
          <Schedule
            startDate={
              currentAnetaPack
                ? Object.keys(currentAnetaPack?.events)[0]
                : moment().format('x')
            }
            events={events}
          />
        </div>
        <div>
          <Homeroom resources={resources} />
        </div>
      </div>
      <div className={styles.anetapackContentButtons}>
        <button
          onClick={handleClose}
          className={buttons.buttonOutline}
          type="button"
        >
          Back
        </button>
        <button
          onClick={() => {
            openNext();
            handleClose();
          }}
          className={buttons.buttomPrimary}
          type="button"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default connect(mstp, {
  getAnetaPackById: getAnetaPackByIdAction,
})(AnetapackContent);
